import { render, staticRenderFns } from "./successMain.vue?vue&type=template&id=0a00cd9a&scoped=true"
import script from "./successMain.vue?vue&type=script&lang=js"
export * from "./successMain.vue?vue&type=script&lang=js"
import style0 from "./successMain.vue?vue&type=style&index=0&id=0a00cd9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a00cd9a",
  null
  
)

export default component.exports